export const CREATE_BOOKING = "CREATE_BOOKING";
export const CREATE_BOOKING_INIT = "CREATE_BOOKING_INIT";
export const CREATE_BOOKING_END = "CREATE_BOOKING_END";
